import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BankAccountClient } from '../clients/oreg-api/account.client';
import { Account } from '../models/account.model';

@Injectable({ providedIn: 'root' })
export class AccountsQuery {
  constructor(private accountClient: BankAccountClient) {}

  getAccountList(worksiteId: string): Observable<Account[]> {
    return this.accountClient.getAccountList(worksiteId);
  }

  getAccount(accountId: string): Observable<Account> {
    return this.accountClient.getAccount(accountId);
  }

  searchAccount(
    accountNumber: string,
    worksiteId: string,
    companyId: string,
  ): Observable<Account> {
    return this.accountClient.searchAccount(
      accountNumber,
      worksiteId,
      companyId,
    );
  }
}
